export const CAROUSEL_GAP = 30;
